// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbItemTop__item":"breadcrumbItemTop__item"};